module.exports = __webpack_public_path__ + "img/jiaqian.bcaaeb78.jpg";